import React, { useContext } from 'react';
import { Context } from './App';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoutes = () => {
  const { user, isResolved } = useContext(Context);
  const location = useLocation();

  // 1) Wait until auth resolution to avoid flicker/misdirect
  if (!isResolved)
    return (
      <div className="centerLoading">
        <CircularProgress />
      </div>
    );

  // 2) Authenticated → render children
  if (user) return <Outlet />;

  // 3) // Send user to /login and include the full current location in state
  return <Navigate to="/login" replace state={{ from: location }} />;
};

export default ProtectedRoutes;
